export const mainContentId = "mainContent"
